
<template>
  <div :ref="'canvas'" class="stage1" :class="anim" />
</template>

<script>
/* eslint-disable no-undef */
export default {
  props: {
    anim: { type: String, default: '/anim/skeleton.json', },
    gameState: { type: String, default: '', },
    isShow: { type: Boolean, default: false },
    idle: { type: String, default: 'TX idle' },
    shakeDish: { type: String, default: 'run lac TX' },
    openDish: { type: String, default: 'open TX BAT' },
    closeDish: { type: String, default: 'close TX BAT' },
    resultDish: { type: String, default: 'open TX DIA' },
    score: { type: Object, default: () => ({})},
    windowFocus: { type: Number, default: 0 },
  },
  data() {
    return {
      app: null,
      spine: null,
      spine1: null,
      spine3: null,
      spriteSheet: null,
      dice1: null,
      dice2: null,
      dice3: null,
      resource: null,
      countComplete: 0,
      entry1: null,
      entry2: null,
      entry3: null,
    }
  },

  computed: {
    dice1Value() {
      return this.score.first !== undefined ? +this.score.first.value : 1;
    },
    dice2Value() {
      return this.score.second !== undefined ? +this.score.second.value : 1;
    },
    dice3Value() {
      return this.score.third !== undefined ? +this.score.third.value : 1;
    },
  },
  watch: {
    windowFocus: function(newVal, oldVal){
      // console.log('[taixiu][canvas-tx-result][watch] windowFocus', newVal, this.gameState);
      this.stopAnimationResult();
    },
    gameState: function(newVal, oldVal){
      if(window.document.hidden) {
        // console.log('[xocdia][canvas-xd-result][watch][gameState]', window.document.hidden);
        // console.log('donot play animation');
        this.stopAnimationResult();
        return;
      }

      if(this.spine1 === null || this.spine3 === null) return;

      if(newVal && newVal === 'RESULTING'){
        // console.log('[canvas-test][watch]', newVal, oldVal);
        const that = this;

        // init
        // hide first layer
        that.spine1.scale.set(0);

        // set dice & make to hide (scale to 0)
        // add dices
        that.secondLayerAnim(that.resource);
        // end init

        that.spine3.stateData.setMix(that.shakeDish, that.openDish, -0.1);
        that.spine3.stateData.setMix(that.openDish, that.closeDish, -3.92);

        // eslint-disable-next-line no-unused-vars
        that.entry1 = that.spine3.state.setAnimation(0, that.shakeDish, false);
        // console.log('entry1', entry1);

        // eslint-disable-next-line no-unused-vars
        that.entry2 = that.spine3.state.addAnimation(0, that.openDish, false, 0);
        // console.log('entry2', entry2);

        that.entry3 = that.spine3.state.addAnimation(0, that.closeDish, false, 0);
        // console.log('entry3', entry3);

        that.countComplete = 0
        that.entry1.onComplete = function() {
          // console.log('entry1 onComplete :)');

          that.countComplete += 1;
          if(that.countComplete === 1) {
            that.spine1.scale.set(0.4);
            that.spine1.state.setAnimation(0, that.resultDish, false);
            that.showSecondLayerAnim();
          }
        }

        that.entry3.onStart = function() {
          // console.log('entry3 onStart :)');
          setTimeout(function(){
            that.hideSecondLayerAnim();
          }, 300);
        }

      }
      if(newVal === 'STOP'){
        this.stopAnimationResult();
      }
    },
  },
  mounted() {
    // eslint-disable-next-line no-undef
    const app = new PIXI.Application({
      width: 740,
      height: 410,
      autoResize: true,
      transparent: true,
      resolution: window.devicePixelRatio
     });
    // document.body.appendChild(app.view);
    this.$refs.canvas.appendChild(app.view);

    // const anim = '/anim/dealer.json';
    const anim = `/anim/skeleton.json`;
    

    // load spine data
    app.loader
    .add('spineboy', anim)
      .load(onAssetsLoaded2);

    this.app = app;
    const that = this;

    function onAssetsLoaded2(loader, res) {
      that.resource = res;
      that.firstLayerAnim(res);
      that.secondLayerAnim(res);
      that.thirdLayerAnim(res);
    }
  },
  methods: {
    stopAnimationResult() {
      if(this.spine1 !== null) this.spine1.state.setAnimation(0, this.idle, false);
      if(this.spine3 !== null) this.spine3.state.setAnimation(0, this.idle, false);
      this.hideSecondLayerAnim();
  
      if(this.entry1 !== null) this.entry1.onComplete = null;
      if(this.entry3 !== null) this.entry3.onStart = null;
    },
    showResult() {
      // console.log('[canvas-result] - showResult');
      this.$emit('showResult');
    },
    firstLayerAnim (res) {
      const spineBoy = new PIXI.spine.Spine(res.spineboy.spineData);

      this.spine1 = spineBoy;

      // set the position
      spineBoy.x = this.app.screen.width / 2;
      spineBoy.y = this.app.screen.height / 2;

      spineBoy.scale.set(0);

      this.app.stage.addChild(spineBoy);
    },
    secondLayerAnim (res) {

      if(this.dice1 !== null) {
        this.app.stage.removeChild(this.dice1);
      }

      if(this.dice2 !== null) {
        this.app.stage.removeChild(this.dice2);
      }

      if(this.dice3 !== null) {
        this.app.stage.removeChild(this.dice3);
      }

      // dice 1
      let y = this.generateY();
      // console.log('dice1Value', this.dice1Value);
      this.dice1 = this.showDice(res, this.dice1Value, 2.2, y);
      this.app.stage.addChildAt(this.dice1, 1);

      // dice 2
      y = this.generateY();
      // console.log('dice2Value', this.dice2Value);
      this.dice2 = this.showDice(res, this.dice2Value, 2, y);
      this.app.stage.addChildAt(this.dice2, 2);

      // dice 3
      y = this.generateY();
      // console.log('dice3Value', this.dice3Value);
      this.dice3 = this.showDice(res, this.dice3Value, 1.8, y);
      this.app.stage.addChildAt(this.dice3, 3);
    },
    thirdLayerAnim (res) {
      const spineBoy = new PIXI.spine.Spine(res.spineboy.spineData);

      this.spine3 = spineBoy;

      // set the position
      spineBoy.x = this.app.screen.width / 2;
      spineBoy.y = this.app.screen.height / 2;

      spineBoy.scale.set(0.4);
      spineBoy.state.setAnimation(0, this.idle, false);

      this.app.stage.addChild(spineBoy);
    },
    showDice(res, dice = 1, x, y) {
      // create a new Sprite from an image path
      const bunny = PIXI.Sprite.from(`/images/dice${dice}.png`);

      // center the sprite's anchor point
      bunny.anchor.set(0.55);

      bunny.scale.set(0);
      // bunny.position.set(1, 1);
      // move the sprite to the center of the screen

      bunny.x = this.app.screen.width / x;
      bunny.y = this.app.screen.height / y;

      return bunny;
    },
    generateY() {
      const y = 2.4 + Math.floor(Math.random() * 50) / 100;
      return y;
    },
    showSecondLayerAnim() {
      this.dice1.scale.set(0.24);
      this.dice2.scale.set(0.24);
      this.dice3.scale.set(0.24);
    },
    hideSecondLayerAnim() {
      if(this.dice1 !== null) this.dice1.scale.set(0);
      if(this.dice2 !== null) this.dice2.scale.set(0);
      if(this.dice3 !== null) this.dice3.scale.set(0);
    },
  }
};
</script>

<style scoped>
.stage1 {
  position: absolute;
  top: 20;
  z-index: 101;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.stage1 canvas {
  touch-action: none!important;
  width: auto !important;
  height: 115% !important;
  cursor: inherit;
}
</style>
